import { API, Endpoints } from '@brg/api'

type ChangeTeamProjectSortingParams = {
  teamId: string
  itemsIds: string[]
}

export const changeTeamProjectSorting = ({
  teamId,
  itemsIds,
}: ChangeTeamProjectSortingParams) => (
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/ChangeProjectSorting')
    .post()
    .body({
      teamId,
      itemsIds,
    })
    .send()
)
import { API, Endpoints } from '@brg/api'

type ChangeTeamProjectSortingParams = {
  teamId: string
  itemsIds: string[]
}

export const changeTeamProjectSorting = ({
  teamId,
  itemsIds,
}: ChangeTeamProjectSortingParams) => (
  API.request()
    .endpoint(Endpoints.geograffee)
    .url('/api/Team/ChangeProjectSorting')
    .post()
    .body({
      teamId,
      itemsIds,
    })
    .send()
)
